<template>
  <div class="chat-typing-indicator">
    <span></span>
    <span></span>
    <span></span>
  </div>
</template>

<script>
import "../../../assets/typing-dots.css";

export default {
  data: () => {
    return {};
  },
};
</script>
